/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import type { Metric } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onINP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onINP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
